window.Theme = window.Theme || {};

document.addEventListener('openfiltersdrawer:click', function () {
  const drawer = document.querySelector('collection-filters-drawer');
  if (drawer && typeof drawer.show === 'function') {
    drawer.show();
  }
});


Theme.querySelectorAll = function (selector, context = document) {
  return Array.from(context.querySelectorAll(selector));
};


Theme.URLParams = {
  set: function (key, value) {
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    history.replaceState(null, '', url);
  },

  get: function (key) {
    const url = new URL(window.location.href);
    return url.searchParams.get(key);
  },

  delete: function (key) {
    const url = new URL(window.location.href);
    url.searchParams.delete(key);
    history.replaceState(null, '', url);
  },

  has: function (key) {
    const url = new URL(window.location.href);
    return url.searchParams.has(key);
  }
};


Theme.Helpers = {
  preload: function (url) {
    if (!url) {
      return;
    }

    const img = new Image();
    img.src = url;
  },

  prefetch: function (url) {
    if (document.querySelector(`link[href="${url}"]`)) {
      return;
    }

    const link = document.createElement("link");

    link.rel = "prefetch";
    link.href = url;

    document.head.appendChild(link);
  },

  debounce: function (fn, delay) {
    let timeout;

    return function() {
      const context = this;
      const args = arguments;

      clearTimeout(timeout);

      timeout = setTimeout(() => {
        fn.apply(context, args);
      }, delay);
    };
  },

  throttle: function (callback, limit) {
    let lastCall = 0;

    return function () {
      const now = Date.now();

      if (now - lastCall >= limit) {
        lastCall = now;
        callback.apply(this, arguments);
      }
    };
  },

  scroll_to: function (id, offset = 80) {
    const target = document.getElementById(id);

    if (!target) {
      return;
    }

    const position = target.offsetTop - offset;

    window.scrollTo({
      top: position,
      behavior: "smooth"
    });
  }
};


Theme.Component = class extends HTMLElement {
  #elements = {};
  #events = {};
  #data = null;

  constructor() {
    super();

    this.elements = {};
  }

  get data() {
    if (this.#data != null) {
      return this.#data;
    }

    const element = this.querySelector(":scope > script[type='application/json']");

    if (!element) {
      return (this.#data = {});
    } else {
      return (this.#data = JSON.parse(element.textContent));
    }
  }

  defineElements(elements) {
    for (const [name, selector] of Object.entries(elements)) {
      this.defineElement(name, selector);
    }
  }

  defineElementsAll(elements) {
    for (const [name, selector] of Object.entries(elements)) {
      this.defineElementAll(name, selector);
    }
  }

  defineElement(name, selector) {
    Object.defineProperty(this.elements, name, {
      get: () => {
        return this.#elements[name] || (this.#elements[name] = this.querySelector(selector));
      }
    });
  }

  defineElementAll(name, selector) {
    Object.defineProperty(this.elements, name, {
      get: () => {
        return this.#elements[name] || (this.#elements[name] = Theme.querySelectorAll(selector, this));
      }
    });
  }

  events() {
    this.#events = {};
    this.addActionAttributeEvents();
    this.setupEventDelegation();
  }

  addActionAttributeEvents() {
    const elements = this.querySelectorAll("[data-action]");

    elements.forEach((element) => {
      const [event, method] = element.dataset.action.split(":");
      const detail = JSON.parse(element.dataset.detail || "{}");

      this.addEvent(event, element, () => {
        this[method](detail, element);
      });
    });
  }

  addEvent(event, element, fn) {
    this.#events[event] ||= [];
    this.#events[event].push({ element, fn });
  }

  setupEventDelegation() {
    for (const [event, handlers] of Object.entries(this.#events)) {
      this.addEventListener(event, (e) => {
        handlers.forEach((handler) => {
          if (this.closestElement(e.target, handler.element)) {
            e.preventDefault();
            handler.fn.apply(this);
          }
        });
      });
    }
  }

  closestElement(starting, matching) {
    let current = starting;

    while (current) {
      if (current === matching) {
        return current;
      }

      current = current.parentElement;
    }

    return null;
  }
}


Theme.ComponentCollection = class {
  #elements = null;

  constructor(selector) {
    this.define(selector);
  }

  define(selector) {
    Object.defineProperty(this, "elements", {
      get: () => {
        return this.#elements || (this.#elements = Theme.querySelectorAll(selector));
      }
    });
  }
};

Theme.ComponentCollections = {};


function updateHeaderHeight() {
  const header = document.querySelector('.sticky-header');
  if (!header) return;

  const headerHeight = header.getBoundingClientRect().height;
  const root = document.documentElement;

  const current = parseFloat(getComputedStyle(root).getPropertyValue('--header-height'));
  if (!Number.isNaN(current) && Math.round(current) === Math.round(headerHeight)) {
    return;
  }

  root.style.setProperty('--header-height', `${headerHeight}px`);
  root.style.setProperty('--header-height-mobile', `${headerHeight}px`);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateHeaderHeight);
} else {
  updateHeaderHeight();
}

window.addEventListener('resize', Theme.Helpers.debounce(updateHeaderHeight, 100));

(function observeHeaderHeight() {
  const header = document.querySelector('.sticky-header');
  if (!header || !window.ResizeObserver) return;

  const ro = new ResizeObserver(() => {
    updateHeaderHeight();
  });

  ro.observe(header);
})();


function captureCardBis() {
  window._bisTriggerCache = {};

  document.querySelectorAll('.klaviyo-product-container').forEach(container => {
    const handle = container.dataset.klaviyoHandle;
    const buttonContainer = container.querySelector('.klaviyo-button-container');
    if (handle && buttonContainer) {
      window._bisTriggerCache[handle] = buttonContainer.cloneNode(true);
    }
  });
}

if (window.location.pathname.includes('/collections/')) {
  document.addEventListener("DOMContentLoaded", captureCardBis);
}

function alignProductCardsHeight() {
  const cards = Array.from(document.querySelectorAll('product-card'));
  if (!cards.length) return;

  const rows = {};
  cards.forEach(card => {
    const info = card.querySelector('[data-product-info]');
    const selectors = card.querySelector('.product-card-selectors');
    if (info) info.style.minHeight = 'auto';
    if (selectors) selectors.style.minHeight = 'auto';
    const top = card.offsetTop;
    rows[top] ||= [];
    rows[top].push({ info, selectors });
  });

  Object.values(rows).forEach(row => {
    const maxInfoHeight = Math.max(...row.map(x => x.info ? x.info.offsetHeight : 0));
    const maxSelectorsHeight = Math.max(...row.map(x => x.selectors ? x.selectors.offsetHeight : 0));
    row.forEach(({ info, selectors }) => {
      if (info) {
        info.style.minHeight = `${maxInfoHeight}px`;
        info.classList.add('is-ready');
      }
      if (selectors) {
        selectors.style.minHeight = `${maxSelectorsHeight}px`;
      }
    });
  });
}
  
document.addEventListener('DOMContentLoaded', alignProductCardsHeight);
window.addEventListener('resize', Theme.Helpers.debounce(alignProductCardsHeight, 200));